import {
    DELETE_MONEY,
    DELETE_PLACE,
    INSERT_MONEY,
    INSERT_PLACE,
    SET_LOADING,
    SET_LOADING_2,
    TRIP_CHANGE,
    UPDATE_MONEY,
    UPDATE_PLACE,
} from './constants';

const initState = {
    tripId: undefined,
    tripName: 'lhv',
    places: [],
    moneys: [],
    loading: false,
    loading2: false,
};

function reducer(state, action) {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload.loading,
            };

        case SET_LOADING_2:
            return {
                ...state,
                loading2: action.payload.loading2,
            };

        case TRIP_CHANGE:
            return {
                ...state,
                ...action.payload,
            };

        case UPDATE_PLACE:
            return {
                ...state,
                places: state.places.map((place) => {
                    if (place.id === action.payload.id)
                        return {
                            ...place,
                            name: action.payload.name,
                        };
                    return place;
                }),
            };

        case DELETE_PLACE:
            return {
                ...state,
                places: state.places.filter(
                    (place) => place.id !== action.payload.id,
                ),
            };

        case INSERT_PLACE:
            const { id, name, tripId } = action.payload;
            return {
                ...state,
                places: [{ id, name, tripId }, ...state.places],
            };

        case INSERT_MONEY:
            let insertMoneys = [{ ...action.payload }, ...state.moneys];
            insertMoneys = insertMoneys.sort((a, b) => {
                if (a.datetime < b.datetime) return 1;
                if (a.datetime > b.datetime) return -1;
                return 0;
            });
            return {
                ...state,
                moneys: insertMoneys,
            };

        case UPDATE_MONEY:
            let moneys = state.moneys.map((money) => {
                if (money.id === action.payload.id)
                    return {
                        ...money,
                        ...action.payload,
                    };
                return money;
            });
            moneys = moneys.sort((a, b) => {
                if (a.datetime < b.datetime) return 1;
                if (a.datetime > b.datetime) return -1;
                return 0;
            });
            return {
                ...state,
                moneys,
            };
        case DELETE_MONEY:
            return {
                ...state,
                moneys: state.moneys.filter(
                    (money) => money.id !== action.payload.id,
                ),
            };
        default:
            throw new Error('Invalid action');
    }
}

export { initState };
export default reducer;
